import { DocketEntryTypeNotificationsGetters } from './partials/notifications'

export const DocketEntryTypeGetters = {
  ...DocketEntryTypeNotificationsGetters,

  docketEntryTypes: state => state.docketEntryTypes,
}
